module.exports = __webpack_public_path__ + "static/woman-with-laptop-e3132e2f69e760be966a2400cc2acfca.png";